import { StandardConstants } from "../standard";

export class ProjectIssuanceConstants {
  public static readonly ISSUANCE_STATUS_DRAFT = "Draft";

  public static readonly ISSUANCE_STATUS_INACTIVE = "Inactive";

  public static readonly ISSUANCE_STATUS_ISSUED = "Issued";

  public static readonly ISSUANCE_STATUS_SELECT_DATA = [
    { key: ProjectIssuanceConstants.ISSUANCE_STATUS_ISSUED, value: ProjectIssuanceConstants.ISSUANCE_STATUS_ISSUED },
    { key: ProjectIssuanceConstants.ISSUANCE_STATUS_DRAFT, value: ProjectIssuanceConstants.ISSUANCE_STATUS_DRAFT },
    {
      key: ProjectIssuanceConstants.ISSUANCE_STATUS_INACTIVE,
      value: ProjectIssuanceConstants.ISSUANCE_STATUS_INACTIVE,
    },
  ];

  public static readonly ISSUANCE_UNIT_MEASUREMENT_CARBON = "Carbon";

  public static readonly ISSUANCE_UNIT_MEASUREMENT_BIODIVERSITY = "Biodiversity";

  public static readonly ISSUANCE_QUANTITY_TYPE_PIU = "PIU";

  public static readonly ISSUANCE_QUANTITY_TYPE_EIU = "EIU";

  public static readonly ISSUANCE_QUANTITY_TYPE_WCU = "WCU";

  public static readonly ISSUANCE_QUANTITY_TYPE_PCU = "PCU";

  public static readonly ISSUANCE_QUANTITY_TYPE_WCC = "WCC";

  public static readonly ISSUANCE_QUANTITY_TYPE_BNG = "BNG";

  public static readonly ISSUANCE_QUANTITY_TYPE_BY_STANDARD: { [key: string]: string[] } = {
    [StandardConstants.WOODLAND_CARBON_CODE_UUID]: ["PIU", "WCU"],
    [StandardConstants.PEATLAND_CODE_UUID]: ["PIU", "PCU"],
    [StandardConstants.WILDER_CARBON_UUID]: ["EIU", "WCC"],
  };

  public static readonly ISSUANCE_QUANTITY_TYPE_LONG_HAND: { [key: string]: string } = {
    [ProjectIssuanceConstants.ISSUANCE_QUANTITY_TYPE_PIU]: "Pending issuance units (PIUs)",
    [ProjectIssuanceConstants.ISSUANCE_QUANTITY_TYPE_EIU]: "Estimated issuance units (EIUs)",
    [ProjectIssuanceConstants.ISSUANCE_QUANTITY_TYPE_WCU]: "Woodland carbon units (WCUs)",
    [ProjectIssuanceConstants.ISSUANCE_QUANTITY_TYPE_PCU]: "Peatland carbon units (PCUs)",
    [ProjectIssuanceConstants.ISSUANCE_QUANTITY_TYPE_WCC]: "Wilder carbon credits (WCCs)",
  };

  public static readonly BNG_UNITKM_HABITAT_TYPES = ["Hedgerow", "Watercourse"];

  public static readonly DEFAULT_BNG_ISSUANCE = {
    uuid: null,
    status: null,
    issuanceDate: null,
    quantityType: ProjectIssuanceConstants.ISSUANCE_QUANTITY_TYPE_BNG,
    soldQuantity: 0,
    reservedQuantity: 0,
    availableQuantity: 0,
    serialNumber: null,
    price: null,
    standardSpecificIssuanceData: {
      createdOrEnhanced: null,
      habitat: null,
      habitatType: null,
      habitatDistinctiveness: null,
      habitatCondition: null,
      unitHa: null,
      unitKm: null,
    },
    rowVersion: null,
    verifierUuid: null,
  };

  public static readonly DEFAULT_CARBON_ISSUANCE = {
    uuid: null,
    status: null,
    issuanceDate: null,
    quantityType: null,
    soldQuantity: 0,
    reservedQuantity: 0,
    availableQuantity: 0,
    serialNumber: null,
    price: null,
    standardSpecificIssuanceData: {
      verificationStatus: null,
      vintageEndDate: null,
      vintageStartDate: null,
    },
    rowVersion: null,
    verifierUuid: null,
  };
}
